var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"not-found-wrapper"},[_c('div',{staticClass:"not-found"},[_c('font-awesome-icon',{attrs:{"icon":"search"}}),_c('div',[_vm._v(_vm._s(_vm.message))]),_c('div',[_vm._v("Seite nicht gefunden")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }